<script lang="ts" setup>
import { MagnifyIcon } from 'mdi-vue3'
import { useI18n } from 'vue-i18n'

import AComboboxInput from '../ACombobox/AComboboxInput.vue'

const { t } = useI18n({
  messages: {
    nl: {
      'Select option...': 'Selecteer optie...',
    },
    en: {
      'Select option...': 'Select option...',
    },
  },
})

export interface SelectSearchEmits {
  (event: 'keydown:backspace'): void
  (event: 'keydown:enter'): void
}

const emit = defineEmits<SelectSearchEmits>()

function onKeyDownBackspace(): void {
  emit('keydown:backspace')
}

function onKeyDownEnter(): void {
  emit('keydown:enter')
}

const modelValue = defineModel<string | undefined>('modelValue', { required: true, default: '' })
</script>

<template>
  <div class="atabix-select-search">
    <AComboboxInput
      v-model="modelValue"
      :placeholder="t('Select option...')"
      v-bind="$attrs"
      @keydown.backspace="onKeyDownBackspace"
      @keydown.enter="onKeyDownEnter"
    />
    <span class="atabix-select-search__icon-wrapper">
      <MagnifyIcon class="atabix-select-search__icon" />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.atabix-select-search {
  @apply relative;
  @apply w-full;
  @apply items-center;
}

.atabix-select-search__icon-wrapper {
  @apply absolute;
  @apply inset-y-0;
  @apply start-0;
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply px-3;
}

.atabix-select-search__icon {
  @apply text-foreground-subtle;
  @apply size-4;
}
</style>
